import { Asset } from "../../types/asset";
import { Image } from "primereact/image";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";
import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";
import { ImageGallerySkeleton } from "./ImageGallerySkeleton";

type Props = {
    className?: string;
    checked?: boolean;
    disabled?: boolean;
    image: Asset;
    onCheck?: (image: Asset) => (event: CheckboxChangeEvent) => void;
};

export const ImagesGalleryItem = (props: Props) => {
    const { className, checked, disabled, image, onCheck } = props;

    return (
        <div
            key={image.asset_id}
            className={classNames(
                "col-4 pb-0 image-gallery-container",
                className
            )}
        >
            {checked ? <div className="image-gallery-checked" /> : null}
            <div>
                <div className="image-header px-4 flex align-items-center justify-content-between">
                    <div className="text-sm ellipsis-text">
                        {decodeURIComponent(image.name)}
                    </div>
                    {image.metadata?.comments ? (
                        <div
                            data-pr-tooltip={image.metadata.comments}
                            data-pr-position="right"
                            data-pr-at="right+5 top"
                            data-pr-my="left center-2"
                            className="pi pi-comment cursor-pointer image-comment surveyor-comments-icon"
                        />
                    ) : null}
                </div>
                <Tooltip target=".surveyor-comments-icon" />
                {image.objectURL ? (
                    <Image
                        imageClassName="image-gallery-item"
                        src={image.objectURL}
                        alt={image.name}
                        preview={!!onCheck}
                    />
                ) : (
                    <ImageGallerySkeleton />
                )}
            </div>
            {onCheck !== undefined ? (
                <div
                    className={classNames("flex justify-content-center pt-1", {
                        "image-gallery-disabled": disabled
                    })}
                >
                    <Checkbox
                        className="mr-2"
                        onChange={onCheck(image)}
                        checked={!!checked}
                        disabled={disabled}
                    />
                    <span>Select image</span>
                </div>
            ) : null}
        </div>
    );
};
